export default [
  {
    path: '/inquiry',
    component: () => import('@/views/inquiry/inquiryList.vue')
  },
  {
    path: '/inquiry/:inquiryNo',
    component: () => import('@/views/inquiry/inquiryDetail.vue')
  }
];